"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(matrix, width) {
  var visibleTimeStart = matrix.inverse().applyToPoint(0, 0).x;
  var visibleTimeEnd = matrix.inverse().applyToPoint(width, 0).x;
  var visibleDuration = visibleTimeEnd - visibleTimeStart;
  return {
    visibleTimeStart: visibleTimeStart,
    visibleTimeEnd: visibleTimeEnd,
    visibleDuration: visibleDuration
  };
};

exports.default = _default;